import React from 'react';
import {useState, useEffect} from 'react';
import {
  Box,
  Grid,
  Stack,
  RadioGroup,
  Radio,
  Center,
  Text,
  GridItem,
  Select
} from '@chakra-ui/react';
import CV1ProcyonChart from './CV1ProcyonChart';
import data from './results.json';


const CV1Metrics = () => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
    const [display, setDisplay] = useState('chart')
    const [isActiveLegend, setIsActiveLegend] = useState(null);
    const [optSelected, setOptSelected] = useState('mobilenetV3');
    const [dataArr, setDataArr] = useState(data.results.mobilenetV3.datasets);
    const [labelArr, setLabelArr] = useState(data.results.labels);
    const [titleData, setTitleData] = useState('MobileNetV3');
    const [textData, setTextData] = useState('Top-1 accuracy and Top-5 accuracy')
    const [titleBox, setTitleBox] = useState('MobileNetV3');
    const [textContentBox, setTextContentBox] = useState('The Top-1 and Top-5 metric is used to evaluate image classification models. The Top5 accuracy means that the model’s answer with the highest confidence matches the ground truth answer. The Top5 accuracy means that the ground truth answer is one of the Top-5 highest confidence predictions.');

    const arrayColors = ["#767171", "#FFC000", "#C00000", "#385723", "#5B9BD5", '#BF40BF', '#722F37', '#000627', '#110909'];

    const onOptionSelected = (opt) => {
      if (typeof opt === 'string' || opt instanceof String) {
      } else {
        opt = opt.target.value
      }
      switch (opt) {
        case 'mobilenetV3':
          setOptSelected('mobilenetV3');
          setDataArr(data.results.mobilenetV3.datasets);
          setLabelArr(data.results.labels);
          setTitleData('MobileNetV3');
          setTextData('Top-1 accuracy and Top-5 accuracy');
          setIsActiveLegend(null);
          setTitleBox('MobileNetV3');
          setTextContentBox('The Top-1 and Top-5 metric is used to evaluate image classification models. The Top5 accuracy means that the model’s answer with the highest confidence matches the ground truth answer. The Top5 accuracy means that the ground truth answer is one of the Top-5 highest confidence predictions.');
          break;
        case 'inceptionV4':
          setOptSelected('inceptionV4');
          setDataArr(data.results.inceptionV4.datasets);
          setLabelArr(data.results.labels);
          setTitleData('InceptionV4');
          setTextData('Top-1 accuracy and Top-5 accuracy');
          setIsActiveLegend(null);
          setTitleBox('InceptionV4');
          setTextContentBox('The Top-1 and Top-5 metric is used to evaluate image classification models. The Top5 accuracy means that the model’s answer with the highest confidence matches the ground truth answer. The Top5 accuracy means that the ground truth answer is one of the Top-5 highest confidence predictions.');
          break;
        case 'yolov3':
          setOptSelected('yolov3');
          setDataArr(data.results.yolov3.datasets);
          setLabelArr(data.results.labels);
          setTitleData('YOLOV3');
          setTextData('Mean Average Precision (mAP) at IoU 0.5 with >75% confidence');
          setIsActiveLegend(null);
          setTitleBox('YOLOV3');
          setTextContentBox('The Mean Average precision (mAP) metric is used to evaluate an object detection model. Once a prediction is made, a confusion matrix is created that identifies which detections fall under true positive, true negative, false positive and false negative based on an (Intersection over Union) IoU threshold (>0.5 with 75% confidence in our case). These are used to calculate the precision and recall values which derive the final mAP value.');
          break;
        case 'resnet50':
          setOptSelected('resnet50');
          setDataArr(data.results.resnet50.datasets);
          setLabelArr(data.results.labels);
          setTitleData('ResNet50');
          setTextData('Top-1 accuracy and Top-5 accuracy');
          setIsActiveLegend(null);
          setTitleBox('ResNet50');
          setTextContentBox('The Top-1 and Top-5 metric is used to evaluate image classification models. The Top5 accuracy means that the model’s answer with the highest confidence matches the ground truth answer. The Top5 accuracy means that the ground truth answer is one of the Top-5 highest confidence predictions.');
          break;
        case 'deeplabV3':
          setOptSelected('deeplabV3');
          setDataArr(data.results.deeplabV3.datasets);
          setLabelArr(data.results.labels);
          setTitleData('DeepLabV3');
          setTextData('Weighted Avg Precision, Weighted Avg Recall, Weighted Avg F1-Score');
          setIsActiveLegend(null);
          setTitleBox('DeepLabV3');
          setTextContentBox('The Precision, Recall and F1 metrics are used to evaluate an image segmentation model. Once a prediction is made, a confusion matrix is created that identifies which detections fall under true positive, true negative, false positive and false negative based on an (Intersection over Union) IoU threshold (>0.5 with 75% confidence in our case). These are used to calculate the precision and recall values which derive the F1 score of the model. The ground truth labels used to calculate these metrics are predictions from the original TensorFlow DeepLabV3 model.');
          break;
        case 'esrgan':
          setOptSelected('esrgan');
          setDataArr(data.results.esrgan.datasets);
          setLabelArr(data.results.labels);
          setTitleData('Real-ESRGAN');
          setTextData('Mean PSNR');
          setIsActiveLegend(null);
          setTitleBox('Real-ESRGAN');
          setTextContentBox('The mean Peak signal-to-noise ratio (PSNR) metric is used to evaluate an image upscaling model. The higher the score, the better the quality of the upscaled image.');
          break;
        default:
          break;
      }
    }

    const onDisplaySelected = (opt) => {
      if (typeof opt === 'string' || opt instanceof String) {
      } else {
        opt = opt.target.value
      }
      setDisplay(opt)
    }

    const onClickLegend = (index) => {
      setIsActiveLegend(index);
    }

    const renderLegend = (dataArr) => {
        return dataArr.map((item, index) => {
          const containerLevel = 'ContainerLevel' + index;
          const level = 'Level' + index;
          return (<Box key={index} onClick={() => onClickLegend(index)} cursor='pointer' id={containerLevel} display={{base: 'inline-block', lg: 'inline-block', md: 'inline-block', sm: 'inline-block'}} pr={{base: '15px', lg: '30px', md: '15px', sm: '15px'}} >
            <Box id={level} display='inline-block' backgroundColor={arrayColors[index]} width='20px' height='20px'></Box> <Text fontWeight='600' className='verticalAlignTop' fontSize='12px' display='inline'>{item.name.type} - {item.name.subname}</Text>
          </Box>);
        })
    }

    useEffect(() => { // check mobile and desktop version. render legend always in mobile as it's always visible the chart
      const handleResize = () => {
        setIsDesktop(window.innerWidth > 991);
        setIsMobile(window.innerWidth <= 991);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    return (
        <Box textAlign="center" fontSize="xl">
            <Grid
                /*templateAreas={`"header header"
          "nav main"
          "footer footer"`}*/
                templateAreas={{base: '"header header" "nav nav" "main main" "footer footer"', lg: '"header header" "nav main""footer footer"', md: '"header header" "nav nav" "main main" "footer footer"', sm:'"header header" "nav nav" "main main" "footer footer"' }}
                gridTemplateRows={{base: '50px 1fr 1fr 0px', lg: '50px 1fr 30px', md: '50px 1fr 320px 0px', sm: '50px 1fr 1fr 0px' }}
                gridTemplateColumns={'320px 1fr'}
                h='200px'
                gap='0'
                color='blackAlpha.700'
            >
                <GridItem pl={{base: '20px', lg: '40px', md: '30px', sm: '20px'}} area={'header'} display='inline-grid' alignItems='center' textAlign='left' borderBottom='1px' borderBottomColor='#E7E7E7' fontSize='15px' color='#59595A' fontWeight='600'>
                  Quality metrics from Procyon AI Computer Vision Models
                </GridItem>
                <GridItem pl={{base: '0px', lg: '20px', md: '10px', sm: '0px'}} area={'nav'} borderRight={{base: '0px', lg: '1px', md: '0px', sm: '0px'}} borderRightColor={{base: '#E7E7E7', lg: '#E7E7E7', md: '#E7E7E7', sm: '#E7E7E7'}} fontSize='15px' color='#59595A'>
                    <Box display={{base: 'block', lg: 'none', md: 'block', sm: 'block'}} pl={{base: '20px', lg: '0', md: '20px', sm: '20px'}} pr={{base: '20px', lg: '0', md: '20px', sm: '20px'}} mt={{base: '20px', lg: '0', md: '20px', sm: '20px'}}>
                      <Text fontSize='15px' display={{base: 'inline', lg: 'inline', md: 'inline', sm: 'inline'}}>{textData} {(optSelected === 'yolov3' || optSelected === 'esrgan') ? 'metric': 'metrics'} with</Text> <Text display={{base: 'inline', lg: 'none', md: 'inline', sm: 'inline'}} fontSize='15px' color='#C02033' fontWeight='bold'>{titleData}</Text>
                    </Box> 
                    <Center>
                        <Box pt={{base: '20px', lg: '40px', md: '30px', sm: '30px'}} pl={{base: '0px', lg: '40px', md: '0px', sm: '0px'}} pr={{base: '0px', lg: '40px', md: '0px', sm: '0px'}} pb={{base: '15px', lg: '40px', md: '20px', sm: '15px'}} width={{base: '90%', lg: 'auto', md: '70%', sm: '85%'}}>
                            <Text marginBottom={{base: '15px', lg: '20px', md: '10px', sm: '10px'}} textAlign='left'>Model</Text>
                            <RadioGroup value={optSelected} onChange={onOptionSelected} width='210px' display={{base: 'none', lg: 'block', md: 'none', sm: 'none'}}>
                                <Stack>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="mobilenetV3"  colorScheme='red'>MobileNetV3</Radio>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="resnet50"  colorScheme='red'>ResNet50</Radio>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="inceptionV4"  colorScheme='red'>InceptionV4</Radio>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="deeplabV3"  colorScheme='red'>DeepLabV3</Radio>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="yolov3"  colorScheme='red'>YOLOV3</Radio>
                                    <Radio size="sm" value="esrgan"  colorScheme='red'>Real-ESRGAN</Radio>
                                </Stack>
                            </RadioGroup>
                            <Select className='chooseBenchmark' value={optSelected} onChange={onOptionSelected} display={{base: 'block', lg: 'none', md: 'block', sm: 'block'}}>
                              <option value="mobilenetV3">MobileNetV3</option>
                              <option value="resnet50">ResNet50</option>
                              <option value="inceptionV4">InceptionV4</option>
                              <option value="deeplabV3">DeepLabV3</option>
                              <option value="yolov3">YOLOV3</option>
                              <option value="esrgan">Real-ESRGAN</option>
                            </Select>
                            {isDesktop && <Text mt={{base: '20px', lg: '40px', md: '20px', sm: '20px'}} marginBottom={{base: '10px', lg: '15px', md: '10px', sm: '10px'}} textAlign='left'>Display</Text>}
                            <RadioGroup onChange={onDisplaySelected} value={display} display={{base: 'none', lg: 'block', md: 'none', sm: 'none'}}>
                                <Stack>
                                    <Radio pb={{base: '15px', lg: '10px', md: '10px', sm: '10px'}} size="sm" value="chart" colorScheme='red'>Chart</Radio>
                                    <Radio size="sm" value="table" colorScheme='red'>Table</Radio>
                                </Stack>
                            </RadioGroup>
                            {isDesktop && <Select onChange={onDisplaySelected} value={display}  display={{base: 'block', lg: 'none', md: 'block', sm: 'block'}}>
                              <option value="chart">Chart</option>
                              <option value="table">Table</option>
                            </Select>}
                        </Box>
                    </Center>
                </GridItem>
                <GridItem pl={{base: '15px', lg: '30px', md: '15px', sm: '15px'}} pr={{base: '15px', lg: 'auto', md: 'auto', sm: '15px'}} pt={{base: '5px', lg: '40px', md: '20px', sm: '20px'}} area={'main'} fontSize='15px' textAlign='left' width={{base: '100%', lg: 'auto', md: '70%', sm: '100%'}} ml={{base: 'auto', lg: '30px', md: 'auto', sm: 'auto'}} mr={{base: 'auto', lg: 'auto', md: 'auto', sm: 'auto'}}>
                  <Box display={{base: 'block', lg: 'block', md: 'block', sm: 'block'}}>
                    <Text fontSize='15px' display={{base: 'none', lg: 'inline', md: 'none', sm: 'none'}}>{textData} {(optSelected === 'yolov3' || optSelected === 'esrgan') ? 'metric': 'metrics'} with</Text> <Text display={{base: 'none', lg: 'inline', md: 'none', sm: 'none'}} fontSize='15px' color='#C02033' fontWeight='bold'>{titleData}</Text>
                  </Box>
                  <Box textAlign='left' className='verticalAlignTop' display={{base: 'block', lg: 'block', md: 'block', sm: 'block'}} pr={{base: 'auto', lg: '30px', md: 'auto', sm: 'auto'}} pl={{base: 'auto', lg: '30px', md: 'auto', sm: 'auto'}} pt={{base: '10px', lg: '30px', md: '20px', sm: '10px'}}>
                      {((isMobile) || ( isDesktop && display === 'chart')) && renderLegend(dataArr)}
                  </Box>
                  <Box id='graphContainer' display={{base: 'block', lg: 'inline-block', md: 'block', sm: 'block'}} position={{base: 'relative', lg: 'relative', md: 'relative', sm: 'relative'}} width={{base: 'auto', xl: '700px', lg: '600px', md: '600px', sm: 'auto'}} height={display === 'chart' ? {base: '900px', lg: '900px', md: '900px', sm: '900px'} : {base: '750px', lg: '750px', md: '900px', sm: '900px'}} mt={{base: '10px', lg: '10px', md: '10px', sm: '10px'}} mb={{base: '20px', lg: '40px', md: '30px', sm: '20px'}}>
                    <CV1ProcyonChart chartData={dataArr} labelsChartData={labelArr} titleBenchmark={titleData} clickedLegendIndex={isActiveLegend} displayOption={display}>
                    </CV1ProcyonChart>
                  </Box>
                  <Box width={{base: 'auto', xl: '700px', lg: '600px', md: '600px', sm: 'auto'}} mt='30px' padding='15px' backgroundColor='#fff' borderRadius='6px' border='2px' borderStyle='solid' borderColor='#939393'>
                      <Text fontWeight='bold' fontSize='18px'>{titleBox}</Text>
                      <Text mt='15px'>{textContentBox}</Text>
                  </Box>
                </GridItem>
                <GridItem pl='2' mt={{base: '0px', lg: '20px', md: '20px', sm: '0px'}} area={'footer'} textAlign='left' fontSize='12px' paddingLeft='40px' paddingRight='40px'>
                </GridItem>
            </Grid>
        </Box>
    );
}

export default CV1Metrics;
